var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76057 14.4043C9.18557 13.8303 8.83557 13.0503 8.83557 12.1753C8.83557 10.4223 10.2476 9.00928 11.9996 9.00928C12.8666 9.00928 13.6646 9.36028 14.2296 9.93428",
    stroke: "#1E2948",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1047 12.7366C14.8727 14.0266 13.8567 15.0446 12.5677 15.2786",
    stroke: "#1E2948",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65463 17.5098C5.06763 16.2638 3.72363 14.4438 2.74963 12.1748C3.73363 9.89583 5.08663 8.06583 6.68363 6.80983C8.27063 5.55383 10.1016 4.87183 11.9996 4.87183C13.9086 4.87183 15.7386 5.56383 17.3356 6.82883",
    stroke: "#1E2948",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4477 9.02832C20.1357 9.94232 20.7407 10.9973 21.2497 12.1743C19.2827 16.7313 15.8067 19.4763 11.9997 19.4763C11.1367 19.4763 10.2857 19.3363 9.46765 19.0633",
    stroke: "#1E2948",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.887 4.28711L4.11304 20.0611",
    stroke: "#1E2948",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeClosed);
export default __webpack_public_path__ + "static/media/icon-eye-closed.a1cb6903cee9dc704be5373f4605c38f.svg";
export { ForwardRef as ReactComponent };